let ga4Initialized = false;

/**
 * Inject the GA4 (gtag.js) script tag into the document head.
 * Uses Advanced Consent Mode — the script loads but cookies are suppressed until consent is granted.
 */
export function initGA4(trackingId: string): void {
  if (ga4Initialized || !trackingId) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(trackingId)}`;
  script.setAttribute('data-analytics', 'ga4');
  document.head.appendChild(script);

  window.gtag('js', new Date());
  window.gtag('config', trackingId, {
    send_page_view: false, // We handle page views manually via router
  });

  ga4Initialized = true;
}

/**
 * Track a page view in GA4.
 */
export function trackPageView(path: string, title: string): void {
  if (!ga4Initialized) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
  });
}
